module.exports = __webpack_public_path__ + "media/images/clearcash-9332fea649604ff8c8d83809e6addbb8.png";